import { createSelector } from 'reselect';
import SearchSelector from 'selectors/page/search/searchSelector';
import Empty from 'constants/empty';

const { searchSelector } = SearchSelector;

// Related-terms data selector: composes the existing searchSelector (page.search).
// Terms ride the SRP response (R-1 de-risked); absent => the shared stable Empty.Array reference.
const relatedSearchTermsSelector = createSelector(searchSelector, search => search?.relatedSearches || Empty.Array);

export { relatedSearchTermsSelector };
